import { Card, CardContent } from './ui/card';
import { LucideIcon } from 'lucide-react';

interface MetricCardProps {
  icon: LucideIcon;
  value: string;
  label: string;
  description?: string;
}

export default function MetricCard({ icon: Icon, value, label, description }: MetricCardProps) {
  return (
    <Card className="group hover:shadow-xl transition-all duration-300 hover:-translate-y-1 border-luxury-silver-light/40">
      <CardContent className="p-8">
        <div className="flex flex-col items-center text-center space-y-4">
          <div className="p-4 bg-brand-primary rounded-full group-hover:bg-brand-primary transition-colors duration-300">
            <Icon className="w-8 h-8 text-white group-hover:text-white transition-colors duration-300" />
          </div>
          <div className="space-y-2">
            <p className="text-4xl font-bold text-brand-primary">{value}</p>
            <p className="text-lg font-semibold text-brand-dark">{label}</p>
            {description && (
              <p className="text-sm text-brand-dark">{description}</p>
            )}
          </div>
        </div>
      </CardContent>
    </Card>
  );
}

